import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationMemberResponse, OrganizationMembersParams } from './types';

export async function getOrganizationMembers(organizationId: string, params: OrganizationMembersParams = {}) {
  const url = `/web/studio/organizations/${organizationId}/members`;

  const queryParams: Record<string, string | number> = {};

  if (params.search) queryParams.search = params.search;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;
  if (params.role) queryParams.role = params.role;
  if (params.sortColumn) queryParams.sort_column = params.sortColumn;
  if (params.sortDirection) queryParams.sort_direction = params.sortDirection;

  const response = await api.executeGetRequest<PaginatedListResponse<OrganizationMemberResponse>>(url, queryParams);

  return response;
}
